import "./styles/css/bootstrap.css";
import "./styles/css/style.css";
import "./styles/css/responsive.css";
import HomePage from "./pages/homepage";

import { Provider } from "react-redux";
import store from "./store";

function App() {
  return (
    <Provider store={store}>
      <div class="page-wrapper rtl">
        <HomePage />
      </div>
    </Provider>
  );
}

export default App;
